<template>
  <div>
    <el-row class="container">
      <AlarmDetails v-model="details"></AlarmDetails>
    </el-row>
    <br>
    <el-row class="container">
      <ComponentSelector v-model="selectedComponents"></ComponentSelector>
    </el-row>
    <br>
    <el-row class="container">
      <PersonnelSelector v-model="personnel"></PersonnelSelector>
    </el-row>
    <br>
    <el-row class="container">
      <StatusSelector v-model="status"></StatusSelector>
    </el-row>
    <br>
    <el-row>
      <el-button style="margin-top: 12px;" @click="validate" type="success">
        <strong>Submit</strong>
      </el-button>
    </el-row>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import AlarmDetails from "../Details/AlarmDetails.vue";
import PersonnelSelector from "../Selectors/PersonnelSelector.vue";
import ComponentSelector from "../Selectors/ComponentSelector.vue";
import StatusSelector from "../Selectors/StatusSelector.vue";
import { alarm } from "../../api/alarm/alarm";
import Moment from "moment";
@Component({
  name: "AddAlarm",
  components: {
    AlarmDetails,
    ComponentSelector,
    PersonnelSelector,
    StatusSelector
  },
  props: {
    obj: {}
  },
  computed: {
    alarmObject: {
      get: function() {
        return this.$data.alarm;
      },
      set: function(newVal) {
        this.$data.alarm.push(newVal);
      }
    }
  }
})
export default class AddAlarm extends Vue {
  public active: number = 0;
  public componentname: string = "AlarmDetails";
  public loading: boolean = true;
  public alarm: any[] = [];
  public details: any = {};
  public selectedComponents: any[] = [];
  public personnel: any[] = [];
  public status: any = [];
  public next() {
    if (this.$props.obj.id === undefined) {
      alarm
        .addAlarm(
          this.$store.getters.getToken,
          this.alarm,
          this.$store.getters.getHost
        )
        .then(r => {
          if (r.status == 400) {
            this.$message.error(r.error);
          } else {
            this.$message.success("Alarm Added");
            this.alarm = [];
            this.$store.dispatch("updateCurrentObject", {});
            this.$store.dispatch("updateCurrentComponent", "AlarmList");
            this.$router.replace({
              name: "load"
            });
          }
        });
    } else {
      alarm
        .editAlarm(
          this.$store.getters.getToken,
          this.alarm,
          this.$store.getters.getHost
        )
        .then(r => {
          if (r.status == 400) {
            this.$message.error(r.error);
          } else {
            this.$message.success("Alarm Edited");
            this.alarm = [];
            this.$store.dispatch("updateCurrentObject", {});
            this.$store.dispatch("updateCurrentComponent", "AlarmList");
            this.$router.replace({
              name: "load"
            });
          }
        });
    }
  }

  public async mounted() {
    if (this.$props.obj.id === undefined) {
      console.log("add");
    } else {
      console.log("edit");
      this.details = {
        name: this.$props.obj.name,
        id: this.$props.obj.id
      };

      this.status = {
        enddate: this.$props.obj.date_completed,
        selectedStatus: this.$props.obj.status
      };
      this.selectedComponents = this.$props.obj.componentIds;
      let addedPersons = await JSON.parse(
        JSON.parse(this.$props.obj.personnel)
      );
      for (const p of addedPersons) {
        let obj = this.personnel.find(obj => obj.id === p.id);
        if (obj != undefined) {
          console.log("upd");
          obj.dates.push({
            date_started: p.date_started,
            date_ended: p.date_ended
          });
        } else {
          console.log("new");
          this.personnel.push({
            id: p.id,
            dates: [{ date_started: p.date_started, date_ended: p.date_ended }]
          });
        }
      }
    }
  }
  public validateStatus(): boolean {
    if (this.status.selectedStatus != undefined) {
      if (this.status.selectedStatus != 2) {
        this.status.enddate = new Date(0);
        this.alarm = this.status;
        return true;
      } else {
        if (this.status.enddate === undefined) {
          this.$message.error("Please add Completion Date");
          return false;
        } else {
          this.alarm = this.status;
          return true;
        }
      }
    } else {
      this.$message.error("Please add Status");
      return false;
    }
  }
  public validateDetails(): boolean {
    if (this.details.name != undefined) {
      this.alarm = this.details;
      return true;
    } else {
      this.$message.error("Please add Description");
      return false;
    }
  }
  public validateComponents(): boolean {
    if (this.selectedComponents.length === 0) {
      this.$message.error("No components selected");
      return false;
    } else {
      this.alarm = this.selectedComponents;
      return true;
    }
  }
  public validate() {
    if (this.validateDetails()) {
      if (this.validateComponents()) {
        if (this.validateStatus()) {
          if (this.validatePersonnel()) {
            console.log(this.alarm);
            this.next();
          }
        }
      }
    }
    this.alarm = [];
  }
  public beforeDestroy() {
    console.log("DESTROY");
    this.$store.dispatch("updateCurrentObject", {});
    this.alarm = [];
  }
  public validatePersonnel(): boolean {
    for (const p of this.personnel) {
      for (const d of p.dates) {
        if (d.date_started === undefined) {
          this.$message.error(
            "Please add Start Date on " + p.firstname + " " + p.lastname
          );
          return false;
        }
        if (d.date_ended === undefined) {
          this.$message.error(
            "Please add End Date on " + p.firstname + " " + p.lastname
          );
          return false;
        }
      }
    }
    this.alarm = this.personnel;
    return true;
  }
}
</script>
<style scoped>
.container {
  border: 5px solid rgb(152, 226, 226);
  border-radius: 10px;
  background-color: rgb(221, 218, 218);
  padding: 5px 5px 5px 5px;
}
strong {
  color: white;
}
</style>
